import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { storage } from '../../config/firebaseConfig';
import { ref, getDownloadURL } from 'firebase/storage';
import { Oval } from 'react-loader-spinner';

// Custom Modal Component for User Manual
const UserManual = ({ isOpen, onClose }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      fetchPdfUrl();
    }
  }, [isOpen]);

  const fetchPdfUrl = async () => {
    try {
      setLoading(true);
      setError(null);
      const pdfRef = ref(storage, 'HowToUse/Habcare Klavuz.pdf');
      const url = await getDownloadURL(pdfRef);
      setPdfUrl(url);
    } catch (err) {
      console.error('Error fetching PDF:', err);
      setError('PDF yüklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  // Create portal to render modal outside of normal DOM hierarchy
  return ReactDOM.createPortal(
    <div style={styles.overlay}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={styles.title}>Kullanım Kılavuzu</h2>
          <button
            onClick={onClose}
            style={styles.closeButton}
          >
            ×
          </button>
        </div>

        <div style={styles.content}>
          {loading ? (
            <div style={styles.loadingContainer}>
              <Oval
                color="#4f46e5"
                secondaryColor="#818cf8"
                height={50}
                width={50}
                visible={true}
              />
              <p style={styles.loadingText}>Kılavuz yükleniyor...</p>
            </div>
          ) : error ? (
            <div style={styles.errorContainer}>
              <p style={styles.errorText}>{error}</p>
              <button onClick={fetchPdfUrl} style={styles.retryButton}>
                Tekrar Dene
              </button>
            </div>
          ) : (
            <iframe
              src={pdfUrl}
              style={styles.iframe}
              title="Kullanım Kılavuzu"
            />
          )}
        </div>

        <div style={styles.footer}>
          <button
            onClick={onClose}
            style={styles.button}
          >
            Kapat
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

// Styles
const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    backgroundColor: 'white',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '1200px',
    height: '85vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
    position: 'relative',
  },
  header: {
    padding: '20px 30px',
    borderBottom: '1px solid #eaeaea',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    margin: 0,
    fontSize: '24px',
    fontWeight: '600',
    color: '#2c3e50',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '28px',
    color: '#7f8c8d',
    cursor: 'pointer',
    padding: '0 5px',
    lineHeight: '1',
  },
  content: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
  },
  loadingText: {
    fontSize: '16px',
    color: '#2c3e50',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    padding: '20px',
  },
  errorText: {
    fontSize: '16px',
    color: '#e74c3c',
    textAlign: 'center',
  },
  retryButton: {
    backgroundColor: '#3498db',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '5px',
    fontWeight: '500',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
  footer: {
    padding: '15px 30px',
    borderTop: '1px solid #eaeaea',
    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: '#f8f9fa',
  },
  button: {
    backgroundColor: '#3498db',
    color: 'white',
    padding: '8px 20px',
    borderRadius: '5px',
    fontWeight: '500',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
};

export default UserManual;
